import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

const categoryImages: Record<string, string> = {
  "Shoes": "https://readdy.ai/api/search-image?query=Clean%20white%20sneakers%20on%20neutral%20background%2C%20minimal%20product%20photo%2C%20soft%20lighting%2C%20simple%20composition&width=120&height=80&seq=mob-cat-shoes&orientation=landscape",
  "Hoodies & Sweaters": "https://readdy.ai/api/search-image?query=Folded%20beige%20hoodie%20on%20wooden%20surface%2C%20minimal%20product%20photo%2C%20warm%20tones%2C%20soft%20lighting%2C%20clean%20composition&width=120&height=80&seq=mob-cat-hoodies&orientation=landscape",
  "T-Shirts": "https://readdy.ai/api/search-image?query=Folded%20white%20cotton%20tshirt%20on%20clean%20surface%2C%20minimal%20product%20photo%2C%20bright%20natural%20light%2C%20simple%20composition&width=120&height=80&seq=mob-cat-tshirt&orientation=landscape",
  "Jackets": "https://readdy.ai/api/search-image?query=Denim%20jacket%20hanging%20on%20minimal%20wooden%20hanger%2C%20neutral%20background%2C%20soft%20lighting%2C%20clean%20product%20photo&width=120&height=80&seq=mob-cat-jackets&orientation=landscape",
  "Pants & Shorts": "https://readdy.ai/api/search-image?query=Folded%20beige%20pants%20on%20linen%20surface%2C%20minimal%20product%20photo%2C%20warm%20natural%20light%2C%20clean%20composition&width=120&height=80&seq=mob-cat-pants&orientation=landscape",
  "Headwear": "https://readdy.ai/api/search-image?query=Neutral%20beige%20cap%20on%20clean%20white%20surface%2C%20minimal%20product%20photo%2C%20soft%20lighting%2C%20simple%20composition&width=120&height=80&seq=mob-cat-headwear&orientation=landscape",
  "Sets": "https://readdy.ai/api/search-image?query=Matching%20clothing%20outfit%20display%20on%20white%20surface%2C%20minimal%20product%20photo%2C%20soft%20lighting%2C%20clean%20arrangement&width=120&height=80&seq=mob-cat-sets&orientation=landscape",
  "Underwear": "https://readdy.ai/api/search-image?query=Folded%20cotton%20basics%20on%20cream%20surface%2C%20minimal%20product%20photo%2C%20soft%20diffused%20light%2C%20clean%20composition&width=120&height=80&seq=mob-cat-underwear&orientation=landscape",
  "Jersey": "https://readdy.ai/api/search-image?query=Sports%20jersey%20hanging%20on%20white%20wall%2C%20minimal%20product%20photo%2C%20bright%20lighting%2C%20clean%20athletic%20aesthetic&width=120&height=80&seq=mob-cat-jersey&orientation=landscape",
  "Accessories": "https://readdy.ai/api/search-image?query=Watch%20and%20sunglasses%20on%20white%20marble%2C%20minimal%20product%20photo%2C%20soft%20lighting%2C%20elegant%20simple%20composition&width=120&height=80&seq=mob-cat-access&orientation=landscape",
  "Bags": "https://readdy.ai/api/search-image?query=Canvas%20tote%20bag%20on%20clean%20white%20surface%2C%20minimal%20product%20photo%2C%20natural%20light%2C%20simple%20clean%20composition&width=120&height=80&seq=mob-cat-bags&orientation=landscape",
  "Belts": "https://readdy.ai/api/search-image?query=Leather%20belt%20rolled%20on%20white%20surface%2C%20minimal%20product%20photo%2C%20warm%20lighting%2C%20simple%20elegant%20composition&width=120&height=80&seq=mob-cat-belts&orientation=landscape",
  "Perfumes": "https://readdy.ai/api/search-image?query=Glass%20perfume%20bottle%20on%20marble%20surface%2C%20minimal%20product%20photo%2C%20soft%20ambient%20light%2C%20elegant%20simple%20composition&width=120&height=80&seq=mob-cat-perfumes&orientation=landscape",
  "Other Stuff": "https://readdy.ai/api/search-image?query=Curated%20lifestyle%20items%20on%20white%20surface%2C%20minimal%20product%20photo%2C%20soft%20lighting%2C%20eclectic%20simple%20composition&width=120&height=80&seq=mob-cat-other&orientation=landscape",
};

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setDropdownOpen(false);
    setMobileCatOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 hover:text-primary-600 transition-colors duration-200"
          >
            Vigorbuy<span className="text-accent-500">Spreadsheet</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap ${
                location.pathname === "/"
                  ? "text-primary-700 bg-primary-50"
                  : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
              }`}
            >
              Home
            </Link>

            <div className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-background-100 transition-all duration-200 whitespace-nowrap"
              >
                Categories
                <i className={`ri-arrow-down-s-line text-sm transition-transform duration-200 ${dropdownOpen ? "rotate-180" : ""}`}></i>
              </button>
              {dropdownOpen && (
                <div className="absolute top-full left-0 mt-1 w-72 bg-background-50 rounded-xl border border-background-200/70 py-2 max-h-96 overflow-y-auto shadow-sm">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors duration-150"
                    >
                      <span className="w-8 h-8 flex-shrink-0 rounded-lg overflow-hidden">
                        <img
                          src={categoryImages[cat.name] || ""}
                          alt={cat.name}
                          className="w-full h-full object-cover"
                          />
                      </span>
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/shopping-guide"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap ${
                location.pathname === "/shopping-guide"
                  ? "text-primary-700 bg-primary-50"
                  : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
              }`}
            >
              Shopping Guide
            </Link>

            <Link
              to="/kakobuy-vs-vigorbuy"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap ${
                location.pathname === "/kakobuy-vs-vigorbuy"
                  ? "text-primary-700 bg-primary-50"
                  : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
              }`}
            >
              Comparison
            </Link>

            <Link
              to="/article/vigorbuy-spreadsheet-complete-guide"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap ${
                location.pathname.startsWith("/article")
                  ? "text-primary-700 bg-primary-50"
                  : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
              }`}
            >
              Guides
            </Link>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="ml-2 px-5 py-2 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
            >
              Buy It Now
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 max-h-[80vh] overflow-y-auto">
          <div className="px-4 py-3 flex flex-col gap-0.5">
            <Link
              to="/"
              className="flex items-center gap-3 px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-home-4-line text-primary-500"></i>
              </span>
              Home
            </Link>

            <Link
              to="/shopping-guide"
              className="flex items-center gap-3 px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-book-open-line text-primary-500"></i>
              </span>
              Shopping Guide
            </Link>

            <Link
              to="/kakobuy-vs-vigorbuy"
              className="flex items-center gap-3 px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-scales-3-line text-primary-500"></i>
              </span>
              Kakobuy vs Vigorbuy
            </Link>

            <button
              onClick={() => setMobileCatOpen(!mobileCatOpen)}
              className="flex items-center justify-between w-full px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors"
            >
              <span className="flex items-center gap-3">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-grid-line text-primary-500"></i>
                </span>
                Categories
              </span>
              <i className={`ri-arrow-down-s-line transition-transform duration-200 ${mobileCatOpen ? "rotate-180" : ""}`}></i>
            </button>

            {mobileCatOpen && (
              <div className="grid grid-cols-2 gap-1.5 px-2 py-2">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="flex items-center gap-2 px-2 py-2.5 rounded-lg hover:bg-background-100 transition-colors"
                  >
                    <span className="w-8 h-8 flex-shrink-0 rounded-lg overflow-hidden">
                      <img
                        src={categoryImages[cat.name] || ""}
                        alt={cat.name}
                        className="w-full h-full object-cover"
                      />
                    </span>
                    <span className="text-xs text-foreground-600 hover:text-primary-600 font-medium leading-tight">
                      {cat.name}
                    </span>
                  </a>
                ))}
              </div>
            )}

            <Link
              to="/article/vigorbuy-spreadsheet-complete-guide"
              className="flex items-center gap-3 px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-article-line text-primary-500"></i>
              </span>
              SEO Guides
            </Link>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="mx-4 my-2 px-5 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-full text-center hover:bg-primary-600 transition-all duration-200"
            >
              Buy It Now
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}